// src\data\products\spek\laptop.tsx
const specifications = {
  gaming: {
    specifications: {
      cpu: "Intel Core i5 - i7 / AMD Ryzen (Gen terbaru)",
      gpu: "Integrated / Nvidia / Radeon",
      ram: "8GB - 16GB",
      disk: "SSD",
      storage: "512GB - 1TB",
      screen: "24-inch - 30-inch",
      other: ["Keyboard", "Mouse"],
    },
    options: {
      cpu: [
        { key: "i3", value: "Intel Core i3" },
        { key: "i5", value: "Intel Core i5" },
        { key: "i7", value: "Intel Core i7" },
      ],
      gpu: [
        { key: "intel", value: "Integrated GPU" },
        { key: "nvidia", value: "Nvidia GeForce" },
        { key: "amd", value: "Radeon" },
      ],
      ram: [
        { key: "8GB", value: "8GB" },
        { key: "16GB", value: "16GB" },
      ],
      disk: [
        { key: "ssd", value: "SSD" },
      ],
      storage: [
        { key: "512gb", value: "512GB" },
        { key: "1tb", value: "1TB" },
      ],
      screen: [
        { key: "24-inch", value: "24 inch" },
        { key: "27-inch", value: "27 inch" },
        { key: "30-inch", value: "30 inch" },
      ],
      other: [
        { key: "keyboard", value: "Keyboard" },
        { key: "mouse", value: "Mouse" },
        { key: "monitor", value: "Monitor" },
        { key: "printer", value: "Printer" },
      ],
    },
  },

  i5: {
    specifications: {
      cpu: "Intel Core i5 (Gen terbaru)",
      gpu: "Integrated / Nvidia / Radeon",
      ram: "8GB - 16GB",
      disk: "SSD",
      storage: "512GB - 1TB",
      screen: "14-inch - 17-inch",
      other: ["Keyboard", "Mouse"],
    },
    options: {
      cpu: [
        { key: "i5", value: "Intel Core i5" },
        { key: "i7", value: "Intel Core i7" },
      ],
      gpu: [
        { key: "intel", value: "Integrated GPU" },
        { key: "nvidia", value: "Nvidia GeForce" },
        { key: "amd", value: "Radeon" },
      ],
      ram: [
        { key: "8GB", value: "8GB" },
        { key: "16GB", value: "16GB" },
      ],
      disk: [
        { key: "ssd", value: "SSD" },
      ],
      storage: [
        { key: "512gb", value: "512GB" },
        { key: "1tb", value: "1TB" },
      ],
      screen: [
        { key: "14-inch", value: "14 inch" },
        { key: "15-inch", value: "15 inch" },
        { key: "17-inch", value: "17 inch" },
      ],
      other: [
        { key: "keyboard", value: "Keyboard" },
        { key: "mouse", value: "Mouse" },
        { key: "monitor", value: "Monitor" },
        { key: "printer", value: "Printer" },
      ],
    },
  },

  i7: {
    specifications: {
      cpu: "Intel Core i7 (Gen terbaru)",
      gpu: "Integrated / Nvidia / Radeon",
      ram: "8GB - 16GB",
      disk: "SSD",
      storage: "512GB - 1TB",
      screen: "14-inch - 17-inch",
      other: ["Keyboard", "Mouse"],
    },
    options: {
      cpu: [
        { key: "i7", value: "Intel Core i7" },
      ],
      gpu: [
        { key: "intel", value: "Integrated GPU" },
        { key: "nvidia", value: "Nvidia GeForce" },
        { key: "amd", value: "Radeon" },
      ],
      ram: [
        { key: "8GB", value: "8GB" },
        { key: "16GB", value: "16GB" },
      ],
      disk: [
        { key: "ssd", value: "SSD" },
      ],
      storage: [
        { key: "512gb", value: "512GB" },
        { key: "1tb", value: "1TB" },
      ],
      screen: [
        { key: "14-inch", value: "14 inch" },
        { key: "15-inch", value: "15 inch" },
        { key: "17-inch", value: "17 inch" },
      ],
      other: [
        { key: "keyboard", value: "Keyboard" },
        { key: "mouse", value: "Mouse" },
        { key: "monitor", value: "Monitor" },
        { key: "printer", value: "Printer" },
      ],
    },
  },

  macbookAir: {
    specifications: {
      brand: "Apple",
      model: "MacBook Air",
      cpu: "Apple M1 / M2",
      gpu: "Integrated Apple GPU",
      ram: "8GB / 16GB",
      disk: "SSD",
      storage: "512GB",
      screen: "13.3-inch",
      camera: "1080p HD",
      other: ["Keyboard", "Mouse"],
    },
    options: {
      ram: [
        { key: "8GB", value: "8GB" },
        { key: "16GB", value: "16GB" },
      ],
      storage: [
        { key: "512gb", value: "512GB" },
        { key: "1tb", value: "1TB" },
      ],
      other: [
        { key: "keyboard", value: "Keyboard" },
        { key: "mouse", value: "Mouse" },
        { key: "printer", value: "Printer" },
      ],
    },
  },

  macbookPro: {
    specifications: {
      brand: "Apple",
      model: "MacBook Pro",
      cpu: "Apple M1 Pro / M2 Pro / i7",
      gpu: "Integrated Apple GPU / Nvidia",
      ram: "16GB",
      disk: "SSD",
      storage: "512GB",
      screen: "14-inch / 16-inch",
      camera: "1080p HD",
      other: ["Keyboard", "Mouse"],
    },
    options: {
      ram: [
        { key: "16GB", value: "16GB" },
        { key: "32GB", value: "32GB" },
      ],
      storage: [
        { key: "512gb", value: "512GB" },
        { key: "1tb", value: "1TB" },
        { key: "2tb", value: "2TB" },
      ],
      other: [
        { key: "keyboard", value: "Keyboard" },
        { key: "mouse", value: "Mouse" },
        { key: "printer", value: "Printer" },
      ],
    },
  },
};

export default specifications;
